import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select, Upload } from 'antd';
import { StyledButton, ThemedButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { ButtonWrap } from 'pages/settings_page/style';
import { ContentWrap, SubHeader, SubHeaderChild, SubHeaderWrap } from '../ad_domain/style';
import { useNavigate } from 'react-router-dom';
import { FormInsideWrap, GmailAuthAbout, TestMailWraper } from './style';
import { UploadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { SweetSweetAlert } from 'component/sweetalert_components';
import {
  resetProgress,
  setStatus,
  setupMaildelivery,
  setupTestGmail,
  setupTestMicrosoft,
  setupTestStandard,
  setupUploadGmailFile,
} from 'redux/slices/setupSlice';
import Swal from 'sweetalert2';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { InputPatternRule } from 'utils/input_pattern';

const EmailDelivery = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [emailForm] = Form.useForm();
  const [emailTestForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [uploadedfile, setUploadedfile] = useState('');
  const [selectedProtocol, setSelectedProtocol] = useState(1);

  useEffect(() => {
    dispatch(setStatus('process'));
    dispatch(resetProgress());
  }, []);

  const handleProtocolChange = (value) => {
    setSelectedProtocol(value);
  };

  const handleTestMail = async () => {
    try {
      await emailForm.validateFields();
      await emailTestForm.validateFields();
    } catch (error) {
      return;
    }
    if (selectedProtocol === 2) {
      if (!uploadedfile) {
        SweetSweetAlert({
          text: 'Please upload Credential File.',
          icon: 'error',
          buttonColor: 'red',
        });
        return;
      }
    }

    let value = emailTestForm.getFieldValue();
    value.authorizationProtocal = emailForm.getFieldValue('authorizationProtocal');

    if (selectedProtocol === 1) {
      value = {
        ...value,
        fromName: emailForm.getFieldValue('fromName'),
        emailAccount: emailForm.getFieldValue('emailAccount'),
        mailServer: emailForm.getFieldValue('mailServer'),
        encryption: emailForm.getFieldValue('encryption'),
        emailPort: parseInt(emailForm.getFieldValue('emailPort')),
        password: emailForm.getFieldValue('password'),
        requiresAuthentication: emailForm.getFieldValue('requiresAuthentication'),
      };
    }
    if (selectedProtocol === 2) {
      value = {
        ...value,
        fromName: emailForm.getFieldValue('fromName'),
        path: uploadedfile,
      };
    }
    if (selectedProtocol === 3) {
      value = {
        ...value,
        objectId: emailForm.getFieldValue('objectId'),
        clientId: emailForm.getFieldValue('clientId'),
        tenantId: emailForm.getFieldValue('tenantId'),
        secret: emailForm.getFieldValue('secret'),
      };
    }
    try {
      setLoading(true);
      let response;
      if (selectedProtocol === 1) {
        response = await dispatch(setupTestStandard(value));
      } else if (selectedProtocol === 2) {
        response = await dispatch(setupTestGmail(value));
      } else if (selectedProtocol === 3) {
        response = await dispatch(setupTestMicrosoft(value));
      }
      if (response.payload && response.payload.status === 200) {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'success', buttonColor: 'green' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async (info) => {
    const { file } = info;

    if (!file) {
      return;
    }

    try {
      setLoading(true);
      const response = await dispatch(setupUploadGmailFile(file.originFileObj));
      if (response.payload.status === 200) {
        SweetSweetAlert({ sweetData: 'File upload success', icon: 'success', buttonColor: 'green' });
        setUploadedfile(info.file.name);
      } else {
        SweetSweetAlert({ text: 'File upload failed', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'File upload failed', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };
  const beforeFileUpload = (file) => {
    if (file.type !== 'application/json') {
      SweetSweetAlert({
        text: 'Invalid file type. Please upload a JSON File.',
        icon: 'error',
        buttonColor: 'red',
      });
      return Upload.LIST_IGNORE;
    }
    return true;
  };
  const onFinish = async (value) => {
    try {
      await emailForm.validateFields();
    } catch (error) {
      return;
    }
    if (selectedProtocol === 2) {
      if (!uploadedfile) {
        Swal.fire({
          icon: 'info',
          text: 'Please upload the Credential File',
          showConfirmButton: true,
          confirmButtonColor: 'blue',
          width: '400px',
          heightAuto: false,
          reverseButtons: true,
          confirmButtonText: 'ok',
          customClass: {
            icon: 'custom-swal-icon',
            title: 'custom-swal-title',
          },
        });
        return;
      }
    }
    let values = {
      fromName: value.authorizationProtocal === 1 ? value.fromName : '',
      emailAccount: value.emailAccount || '',
      mailServer: value.mailServer || '',
      encryption: value.encryption || '',
      emailPort: parseInt(value.emailPort) || 0,
      password: value.password || '',
      requiresAuthentication: value.requiresAuthentication || false,
      toName: '',
      microsoftEmail: {
        objectId: value.objectId || '',
        clientId: value.clientId || '',
        tenantId: value.tenantId || '',
        secret: value.secret || '',
        toName: '',
      },
      gmail: {
        fromName: value.authorizationProtocal === 2 ? value.fromName : '',
        toName: '',
        path: value.authorizationProtocal === 2 ? uploadedfile : '',
      },
      mailSettings: {
        protocol: value.authorizationProtocal,
      },
    };
    try {
      setLoading(true);
      const response = await dispatch(setupMaildelivery(values));
      if (response.payload && response.payload.status === 200) {
        const result = await Swal.fire({
          icon: 'success',
          title: response.payload.data,
          showConfirmButton: true,
          confirmButtonColor: 'green',
          width: '400px',
          heightAuto: false,
          confirmButtonText: 'Login',
          customClass: {
            container: 'custom-swal-container',
            icon: 'custom-swal-icon',
            title: 'custom-swal-title',
          },
        });
        if (result.isConfirmed) {
          navigate('/login');
        }
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContentWrap>
      {loading && <ModalOpenLoader />}
      <SubHeaderWrap className='emailHeader'>
        <SubHeader>Configure Your Email Delivery:</SubHeader>
        <SubHeaderChild className='marginLeft'>(You may skip configure later)</SubHeaderChild>
      </SubHeaderWrap>
      <Form
        form={emailForm}
        name='emailDelivery'
        size='large'
        scrollToFirstError
        onFinish={onFinish}
        initialValues={{ authorizationProtocal: selectedProtocol, encryption: 'Plain' }}
      >
        <FormInsideWrap className='emaildelivery'>
          {selectedProtocol !== 3 && (
            <Form.Item
              name='fromName'
              label={selectedProtocol === 2 ? 'User Email Id' : 'From Name'}
              rules={[
                {
                  required: true,
                  message: 'Please Enter this Field',
                },
                {
                  pattern: InputPatternRule.pattern,
                  message: InputPatternRule.message,
                },
              ]}
            >
              <Input />
            </Form.Item>
          )}

          <Form.Item
            name='authorizationProtocal'
            label='Authorization Protocol'
            style={{ marginBottom: selectedProtocol === 2 ? '5px' : '' }}
          >
            <Select onChange={handleProtocolChange} defaultValue={1}>
              <Select.Option value={1}>Standard(SMTP)</Select.Option>
              <Select.Option value={2}>Gmail Account (OAuth 2.0)</Select.Option>
              <Select.Option value={3}>Office 365 (OAuth 2.0)</Select.Option>
            </Select>
          </Form.Item>
          {selectedProtocol === 1 && (
            <>
              <Form.Item
                name='emailAccount'
                label='Email Account'
                rules={[
                  {
                    required: true,
                    message: 'Please Enter this Field',
                  },
                  {
                    type: 'email',
                    message: `Please Enter the E-mail`,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name='mailServer'
                label='Mail Server'
                rules={[
                  {
                    required: true,
                    message: 'Please Enter this Field',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item name='encryption' label='Encryption'>
                <Select showSearch placeholder='Select' defaultValue='Plain'>
                  <Select.Option value='Plain'>Plain</Select.Option>
                  <Select.Option value='SSL'>SSL</Select.Option>
                  <Select.Option value='TLS'>TLS</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                name='emailPort'
                label='Email Port'
                rules={[
                  {
                    required: true,
                    message: 'Please Enter this Field',
                  },
                ]}
              >
                <Input type='number' />
              </Form.Item>
              <Form.Item
                name='password'
                label='Mail Password'
                rules={[
                  {
                    required: true,
                    message: 'Please Enter your Password!',
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item name='requiresAuthentication' label='Requires Authentication' valuePropName='checked'>
                <Checkbox onChange={(e) => emailForm.setFieldsValue({ requiresAuthentication: e.target.checked })} />
              </Form.Item>
            </>
          )}

          {selectedProtocol === 2 && (
            <>
              <GmailAuthAbout>
                <a
                  href='https://dartinnovations.com/setting-up-gmail-oauth-2la-for-your-web-application/'
                  target='blank'
                >
                  Google OAuth Setup?
                </a>
              </GmailAuthAbout>
              <Form.Item name='path' label='Service Account JSON'>
                <Upload onChange={handleFileUpload} showUploadList={false} beforeUpload={beforeFileUpload}>
                  <Button icon={<UploadOutlined />}>Click to Upload Json</Button>
                </Upload>
                {uploadedfile && <p style={{ marginBottom: '0px', marginLeft: '3px', color: 'red' }}>{uploadedfile}</p>}
              </Form.Item>
            </>
          )}

          {selectedProtocol === 3 && (
            <>
              <Form.Item
                name='objectId'
                label='Object ID'
                rules={[
                  {
                    required: true,
                    message: 'Please Enter this Field',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name='clientId'
                label='Client Id'
                rules={[
                  {
                    required: true,
                    message: 'Please Enter this Field',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name='tenantId'
                label='Tenant Id'
                rules={[
                  {
                    required: true,
                    message: 'Please Enter this Field',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name='secret'
                label='Secret'
                rules={[
                  {
                    required: true,
                    message: 'Please Enter this Field',
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </>
          )}
          <div>
            <SubHeader style={{ fontSize: '16px' }}>Test Connection:</SubHeader>
            <Form
              form={emailTestForm}
              initialValues={{
                toName: '',
              }}
              size='large'
            >
              <TestMailWraper>
                <div style={{ width: '100%' }}>
                  <Form.Item
                    name='toName'
                    label='Email'
                    rules={[
                      {
                        required: true,
                        message: 'Please Enter your Email!',
                      },
                      {
                        type: 'email',
                        message: `Please Enter the E-mail`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </div>
                <div style={{ marginLeft: '20px' }}>
                  <Form.Item style={{ textAlign: 'end' }}>
                    <ThemedButton className='test_mail' htmlType='button' onClick={handleTestMail}>
                      Send
                    </ThemedButton>
                  </Form.Item>
                </div>
              </TestMailWraper>
            </Form>
          </div>
        </FormInsideWrap>

        <ButtonWrap>
          <StyledButton type='primary' onClick={() => navigate('/login')}>
            Skip For Now
          </StyledButton>
          <StyledButton type='primary' htmlType='submit'>
            Submit
          </StyledButton>
        </ButtonWrap>
      </Form>
    </ContentWrap>
  );
};

export default EmailDelivery;
